<template>
    <CRow>
        <CCol col>
            <ejs-grid ref='grid' :dataSource="supplierData" :allowFiltering='true' :allowPaging="true" :allowResizing='true' :toolbarClick='toolbarClick' :allowExcelExport='true' :excelExportComplete='excelExportComplete' :allowReordering='true' :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' :actionBegin="actionBegin" :actionComplete='actionComplete' :actionFailure="actionFailure" :filterSettings='filterOptions'>
                <e-columns>
                    <e-column field='supplierId' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                    <e-column field='supplierName' headerText='Name' :validationRules="nameRules" width=120></e-column>
                    <e-column field='active' headerText='Active' displayAsCheckBox='true' editType='booleanedit' width=120></e-column>
                    <e-column field='stateId' headerText='Country' textAlign='Right' :validationRules="requiredRules" editType='dropdownedit' :edit='countryParams' foreignKeyField="stateId" foreignKeyValue='stateName' :dataSource='countries' width=90></e-column>
                    <e-column field='stateName' headerText='Country' :visible='false' width=120></e-column>
                    <e-column field='utilityNames' headerText='Utilities' width=120></e-column>
                    <e-column field='utilities' :validationRules="requiredRules" headerText='Utilities' :visible='false' textAlign='Right' editType='dropdownedit' :edit='utilityParams' foreignKeyField="utilityTypeId" foreignKeyValue='utilityTypeName' :dataSource='utilities' width=90></e-column>
                </e-columns>
            </ejs-grid>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DropDownList } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../../common/syncfusion';
    import gridOptions from '../../../common/gridOptions';
    import store from '../../../store';
    import { MultiSelectPlugin, MultiSelect } from "@syncfusion/ej2-vue-dropdowns"; 

    Vue.use(MultiSelectPlugin); 
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);

    let utilities = SyncHelper.getDataManager('Utils/utilities');

    let states = SyncHelper.getDataManager('Utils/states');
    let roleObj, roleElem, elState, dpState;
    export default {
        components: {
        },
        data() {
            return {
                store: store,
                utilities: utilities,
                supplierData: SyncHelper.getDataManager("Supplier"),
                utilityParams: {
                    create: () => {
                        roleElem = document.createElement('input');
                        return roleElem;
                    },
                    read: () => {
                        return roleObj.value;
                    },
                    destroy: () => {
                        roleObj.destroy();
                    },
                    write: (args) => {
                        roleObj = new MultiSelect({
                            dataSource: utilities,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: args.rowData.utilities,
                            placeholder: 'Utilities',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input'
                        });
                        roleObj.appendTo(roleElem);
                    }
                },
                countries: states,
                countryParams: {
                    create: () => {
                        elState = document.createElement('input');
                        return elState;
                    },
                    read: () => {
                        return dpState.value;
                    },
                    destroy: () => {
                        dpState.destroy();
                    },
                    write: (args) => {
                        dpState = new DropDownList({
                            dataSource: this.countries,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Country',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input'
                        });
                        dpState.appendTo(elState);
                    }
                },
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.Suppliers.Update"],
                    allowAdding: store.state.permissions["Permissions.Suppliers.Create"],
                    allowDeleting: store.state.permissions["Permissions.Suppliers.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                nameRules: { required: true, maxLength: 512 },
                requiredRules: { required: true },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                if (args.item.id.includes('excelexport')) {
                    this.$refs.grid.getColumns()[3].visible = false;
                    this.$refs.grid.getColumns()[4].visible = true;
                   
                }
                gridOptions.excelExport(args, "Suppliers.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
                this.$refs.grid.getColumns()[4].visible = false;
                this.$refs.grid.getColumns()[3].visible = true;
                this.$refs.grid.getColumns()[0].visible = false;
            },
            actionBegin(args) {
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].field == "utilityNames") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        } else if (this.$refs.grid.getColumns()[i].field == "utilities") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        }
                    }
                }

                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));

                }

                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                console.log(args);
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.grid.getColumns().length; i++) {
                        if (this.$refs.grid.getColumns()[i].field == "utilityNames") {
                            this.$refs.grid.getColumns()[i].visible = true;
                        } else if (this.$refs.grid.getColumns()[i].field == "utilities") {
                            this.$refs.grid.getColumns()[i].visible = false;
                        }
                    }
                    const arrayFields = ["supplierName"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }
                if (args.requestType === 'save' && args.action === 'add') {
                    let message = { title: 'Success!', content: 'Supplier is added successfully', cssClass: 'e-toast-success' };
                    this.$root.$emit('showToast', message);
                }
                //if (args.requestType === 'delete') {
                //    let message = { title: 'Success!', content: 'Supplier is deleted successfully', cssClass: 'e-toast-success' };
                //    this.$root.$emit('showToast', message);
                //}
            },
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            }

        },

        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };

</script>
<style>
</style>
